import { API, setAuthToken } from "../../../config/API.js";

export const getDevelopmentData = () => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/development`);
};

export const updDevelopmentData = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/development/edit", params);
};
